import React from 'react'

// material ui
import Typography from '@mui/material/Typography'

// local components
import Wrapper from './Wrapper'
import NotificationText from './NotificationText'

const Notifications = props => {
  const {
    account, // via withQuery
    basename, // passed prop via Rails
    ignore = [] // passed prop via parent
  } = props

  if (!account || !account.notifications) {
    return null
  }

  // filter out any ignored notifications
  const notifications = account.notifications.filter(
    notification => !ignore.some(id => notification.id === id)
  )

  const registrationNotifications = notifications.filter(
    notification => notification.category === 'registration'
  )

  const alertNotifications = notifications.filter(
    notification => notification.category === 'alert'
  )

  if (notifications.length === 0) {
    return null
  }

  return (
    <>
      {alertNotifications.length > 0 && (
        <Wrapper bgcolor='error.dark'>
          <Typography>
            {alertNotifications.map(notification => (
              <NotificationText
                color='common.white'
                key={notification.id}
                basename={basename}
                notification={notification}
              />
            ))}
          </Typography>
        </Wrapper>
      )}

      {registrationNotifications.length > 0 && (
        <Wrapper bgcolor='warning.main'>
          <Typography color='text.primary'>
            Before your campers attend Camp, please:
          </Typography>
          <Typography>
            {registrationNotifications.map(notification => (
              <NotificationText
                color='text.primary'
                key={notification.id}
                basename={basename}
                notification={notification}
              />
            ))}
          </Typography>
        </Wrapper>
      )}
    </>
  )
}

export default Notifications
